document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.c-service-switch .c-service-flow__item[data-step]')) {
    const wrapper = document.querySelector('.c-service-switch');
    wrapper.querySelectorAll('.c-service-flow__item[data-step]').forEach(button => {
      button.addEventListener('click', setStep, false);
    })

    function setStep(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();

        const step = e.target.dataset.step;
        if (step) {
          wrapper.dataset.step = step;
        }
      }
    }
  }
})